export default "__VITE_ASSET__Vt6k8NM4__"